import moment from 'moment';

export default (() => {
function getCookie(c_name) {
      var c_value = ' ' + document.cookie;
      var c_start = c_value.indexOf(' ' + c_name + '=');
      if (c_start == -1) {
          c_value = null;
      }
      else {
          c_start = c_value.indexOf('=', c_start) + 1;
          var c_end = c_value.indexOf(';', c_start);
          if (c_end == -1) {
              c_end = c_value.length;
          }
          c_value = unescape(c_value.substring(c_start,c_end));
      }
      return c_value;
    }
    $('.find-a-room-widget .range-date-picker')
    .daterangepicker({
                      autoApply: true,
                      showDropdowns: false,
                      opens: 'center',
                      minDate: new Date(),
                      locale: {
                          format: 'DD/MM/YYYY',
                          'daysOfWeek': [
                            'Sun',
                            'Mon',
                            'Tue',
                            'Wed',
                            'Thu',
                            'Fri',
                            'Sat',
                        ],
                        'monthNames': [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                            'August',
                            'September',
                            'October',
                            'November',
                            'December',
                        ],
                        firstDay: 1,
                      },
                      startDate: moment().add(1, 'days'), 
                      endDate: moment().add(2, 'days'),
                  })
                  
    $('.find-a-room-widget button.submit').click(function(e) {
        e.preventDefault();

        let parent = $(this).parents('.find-a-room-widget'),
            startDate = parent.find('.range-date-picker').data('daterangepicker').startDate,
            endDate = parent.find('.range-date-picker').data('daterangepicker').endDate,
            adults = parent.find('.adults').val(),
            children = parent.find('.children').val(),
            rooms = parent.find('.rooms').val(),
            hotelCode = parent.data('hotel-code'),
            regionCode = parent.data('region-code'),
            rateCode = parent.data('rate-code'),
            pmid = parent.data('pmid'),
            extraParams = parent.data('extra-params') ? `&${parent.data('extra-params')}` : '',
            customURL = parent.data('custom-url') ? parent.data('custom-url') : false;
        
    
        let checkInDate = startDate.format('DD');
	let checkInMonth = startDate.month().toString();
        let checkInMonthYear = `${checkInMonth.length < 2 ? `0${checkInMonth}` : checkInMonth}${startDate.year()}`;
        let checkOutDate = endDate.format('DD');
	let checkOutMonth = endDate.month().toString();
        let checkOutMonthYear = `${checkOutMonth.length < 2 ? `0${checkOutMonth}` : checkOutMonth}${endDate.year()}`;
	console.log(checkInMonth, checkInMonthYear, checkOutMonth, checkOutMonthYear);    
        if (!checkInDate || !checkOutDate || !adults || !children || !rooms)
        {
          return;
        }

        let url = `https://www.crowneplaza.com/redirect?path=asearch&brandCode=cp&localeCode=en&regionCode=${regionCode}&hotelCode=${hotelCode}&checkInDate=${checkInDate}&checkInMonthYear=${checkInMonthYear}&checkOutDate=${checkOutDate}&checkOutMonthYear=${checkOutMonthYear}&numberOfAdults=${adults}&numberOfChildren=${children}&numberOfRooms=${rooms}&rateCode=${rateCode}&_PMID=${pmid}${extraParams}`;
        
        if(customURL) {
          if(customURL.indexOf('www.ihg.com') !== -1) {
            url = `${customURL}&qAdlt=${adults}&qRms=${rooms}&qChld=${children}&qCiMy=${checkInMonthYear}&qCiD=${checkInDate}&qCoMy=${checkOutMonthYear}&qCoD=${checkOutDate}`;
          } else {
            url = `${customURL}&checkInDate=${checkInDate}&checkInMonthYear=${checkInMonthYear}&checkOutDate=${checkOutDate}&checkOutMonthYear=${checkOutMonthYear}&numberOfAdults=${adults}&numberOfChildren=${children}&numberOfRooms=${rooms}`;
          }
        }

                var utmcsr = getCookie('omniture_parameter');
        if (!utmcsr)
        {
          window.open(
            url,
            '_blank'
          );
       
        } else {
          url = url + `&${utmcsr}`;

          window.open(
            url,
            '_blank'
          );
        }
      });
});



// WEBPACK FOOTER //
// ./scripts/components/find-a-room.js